import * as React from 'react';
const ChipColorContext = /*#__PURE__*/React.createContext({
  disabled: undefined,
  variant: undefined,
  color: undefined
});
export default ChipColorContext;